import { api } from "./apiClient";

const clubSupportAPI = {
  getSupportMessages(params) {
    return api.get("/club-support/messages", { params }).then((r) => r.data);
  },
  sendSupportMessage(body) {
    return api.post("/club-support/messages", body).then((r) => r.data);
  },
  editSupportMessage(messageId, body) {
    return api
      .patch(`/club-support/messages/${encodeURIComponent(messageId)}`, body)
      .then((r) => r.data);
  },
  deleteSupportMessage(messageId) {
    return api
      .delete(`/club-support/messages/${encodeURIComponent(messageId)}`)
      .then((r) => r.data);
  },
  getSupportUnread() {
    return api.get("/club-support/unread").then((r) => r.data);
  },
  uploadSupportMedia(file) {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/club-support/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 180000,
      })
      .then((r) => r.data);
  },
};

export default clubSupportAPI;
